export const modalProps = {
    title: 'Crossborder',
    subtitle:
        'Czas na ekspansję międzynarodową Twojego sklepu? Sprawdź jak może Ci w tym pomóc usługa Crossborder.',
    accordionData: [
        {
            title: 'Opieka wdrożenia',
            items: [
                '<b>Konfiguracja sklepu</b> zgodna z zakresem wybranego pakietu',
                '<b>Opieka nad całością procesu</b>',
                'Wsparcie <b>w wyborze odpowiednich rozwiązań pod kątem rynku docelowego</b>',
                '<b>Tłumaczenie</b> Twojego sklepu na <b>dany język</b>',
            ],
        },
        {
            title: 'Szkolenia',
            subtitle: 'wprowadzające do IdoSell',
            items: [
                'Dostęp do <b>nagrań szkoleniowych z instrukcją obsługi panelu oraz kluczowych integracji</b>',
                '<b>Sesja Q&A</b>',
            ],
        },
        {
            title: 'Konfiguracja',
            subtitle: 'kluczowych funkcjonalności na rynki zagraniczne',
            items: [
                'Konfiguracja <b>płatności</b> na wybrane rynki zagraniczne',
                'Konfiguracja <b>dostaw</b> na wybrane rynki zagraniczne',
                'Konfiguracja <b>magazynów</b>',
                'Dostęp do <b>automatycznego tłumaczenia 10 milionów darmowych znaków</b>',
                '<b>Dostosowanie sklepu pod kątem wizualnym do sklepu macierzystego</b>',
                '<b>Dostęp do listy rozwiązań, które najlepiej sprawdzą się dla danego rynku</b>',
            ],
        },
        {
            title: 'Kompleksowe tłumaczenie',
            items: [
                'Szablonu sklepu',
                'Oferty towarów',
                'Wiadomości transakcyjnych',
                'Strony CMS',
                'Wpisów blogowych i aktualności',
                'Stref rekomendacji',
                'Podstawowych ustawień SEO',
            ],
        },
        {
            title: 'Import danych',
            items: [
                'Import <b>oferty towarów</b>',
                'Import <b>bazy klientów</b>',
                'Import <b>przekierowań adresów towarów</b> (pod kątem SEO)',
            ],
        },
    ],
    price: '2 950 zł',
    priceInfo: '/netto + cena pakietu wdrożeniowego',
    link: 'https://www.idosell.com/pl/abonamenty/',
    linkName: "Sprawdź abonamenty",
};